import { RouteProps } from "react-router-dom";
import { MainPage } from "../pages/Main";
import { AboutPage } from "../pages/About";
import { ContactsPage } from "../pages/Contacts";
import { ServicesPage } from "../pages/Services";

export enum AppRoutes {
  MAIN = "main",
  ABOUT = "about",
  SERVICES = "services",
  CONTACTS = "contacts",
}

interface Link {
  path: string;
  name: string;
}

export const RoutePaths: Record<AppRoutes, Link> = {
  [AppRoutes.MAIN]: { path: "/", name: "Главная" },
  [AppRoutes.ABOUT]: { path: "/about", name: "О нас" },
  [AppRoutes.SERVICES]: { path: "/services", name: "Услуги" },
  [AppRoutes.CONTACTS]: { path: "/contacts", name: "Контакты" },
};

export const routeConfig: Record<AppRoutes, RouteProps> = {
  [AppRoutes.MAIN]: {
    path: RoutePaths.main.path,
    element: <MainPage />,
  },
  [AppRoutes.ABOUT]: {
    path: RoutePaths.about.path,
    element: <AboutPage />,
  },
  [AppRoutes.CONTACTS]: {
    path: RoutePaths.contacts.path,
    element: <ContactsPage />,
  },
  [AppRoutes.SERVICES]: {
    path: RoutePaths.services.path,
    element: <ServicesPage />,
  },
};
